import moment from 'moment';
import ListType from './converters/ListType';
import DTO from './DTO';
import {
  email,
  maxLength50,
  minLength3,
  required,
  trimError, onlyLettersAndHyphen,
} from '../utils/validation';
import DtoType from './converters/DtoType';
import ParkingMeterDTO from './ParkingMeterDTO';
import ObjectType from './converters/ObjectType';

class HostProblemDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'available_status',
        type: Number,
        validators: [],
        labelKey: 'available_status',
      },
      {
        name: 'host',
        type: String,
        validators: [],
        labelKey: 'host',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'name',
      },
      {
        name: 'last_ping_at',
        type: String,
        validators: [],
        labelKey: 'last_ping_at',
      },
      {
        name: 'status',
        type: Number,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'type',
        type: Number,
        validators: [],
        labelKey: 'type',
      },
      {
        name: 'last_unsolved_problem',
        type: ObjectType([
          {
            name: 'hash',
            type: String,
            validators: [],
            labelKey: 'hash',
          },
          {
            name: 'host_id',
            type: String,
            validators: [],
            labelKey: 'host_id',
          },
          {
            name: 'message',
            type: String,
            validators: [],
            labelKey: 'message',
          },
          {
            name: 'is_solved',
            type: Boolean,
            validators: [],
            labelKey: 'is_solved',
          },
          {
            name: 'created_at',
            type: moment,
            validators: [],
            labelKey: 'createdAt',
          },
          {
            name: 'solved_at',
            type: moment,
            validators: [],
            labelKey: 'solved_at',
          },
        ]),
        validators: [],
        labelKey: 'last_unsolved_problem',
      },
      {
        name: 'zbx_address',
        type: String,
        validators: [],
        labelKey: 'zbx_address',
      },
      {
        name: 'zbx_zone',
        type: String,
        validators: [],
        labelKey: 'zbx_zone',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default HostProblemDTO;
